import { useEffect, useRef } from "react";

// Tally embed section. Loads the Tally widget script once, then renders the
// iframe with data-tally-src so the widget can size it dynamically.
export default function TallyForm() {
  const containerRef = useRef(null);

  useEffect(() => {
    const SRC = "https://tally.so/widgets/embed.js";
    const load = () => {
      if (window.Tally && typeof window.Tally.loadEmbeds === "function") {
        window.Tally.loadEmbeds();
      } else {
        // Fallback: swap data-tally-src → src if widget didn't initialise
        containerRef.current?.querySelectorAll("iframe[data-tally-src]").forEach((el) => {
          el.src = el.dataset.tallySrc;
        });
      }
    };

    const existing = document.querySelector(`script[src="${SRC}"]`);
    if (existing) {
      load();
    } else {
      const s = document.createElement("script");
      s.src = SRC;
      s.async = true;
      s.onload = load;
      s.onerror = load; // still try to render via fallback
      document.body.appendChild(s);
    }
  }, []);

  return (
    <section
      id="free-audit-form"
      data-testid="free-audit-form"
      className="bg-slate-50 border-y border-slate-100"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <div className="text-center max-w-3xl mx-auto reveal">
          <div className="text-xs font-bold uppercase tracking-widest text-blue-600">
            Free Growth Audit
          </div>
          <h2 className="mt-3 font-display text-3xl md:text-5xl font-bold text-slate-900 tracking-tight">
            Book Your Free Growth Audit
          </h2>
          <p className="mt-4 text-slate-600 text-base md:text-lg leading-relaxed">
            Share your details and we&apos;ll review your website, SEO visibility, paid ads,
            lead funnel and automation opportunities.
          </p>
        </div>

        <div
          ref={containerRef}
          className="mt-10 md:mt-14 rounded-3xl border border-slate-200 bg-white shadow-sm p-4 md:p-6 reveal"
        >
          <iframe
            data-tally-src="https://tally.so/embed/LZyNep?alignLeft=1&hideTitle=0&transparentBackground=1&dynamicHeight=1"
            loading="lazy"
            width="100%"
            height="800"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            title="The Growth Pilot — Free Growth Audit Form"
            data-testid="tally-iframe"
            style={{ width: "100%", minHeight: 720, border: 0, background: "transparent" }}
          />
        </div>

        <p className="mt-6 text-center text-xs text-slate-500">
          Your details are private. We&apos;ll only use them to prepare your free audit.
        </p>
      </div>
    </section>
  );
}
